<template>
  <div class="page_ blue_">
    <div class="top_ acco_tab">
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" :tab="$t('InsuranceInfo[0]') || '有效保单'">
          <div class="box_" v-if="effectivePolicyList.length > 0">
            <div
              v-for="(item, index) in effectivePolicyList"
              :key="index"
              style="margin-bottom: 20px;"
            >
              <p class="tit_">
                {{ $t("InsuranceInfo[1]") || "保单号" }}：{{ item.policyNo }}
              </p>
              <div class="main_info_" v-if="item.show != '1'">
                <div class="top">
                  <span class="left_">{{
                    $t("InsuranceInfo[2]") || "主被保险人"
                  }}</span>
                  <div class="right_">
                    <div class="add" @click="addCard">
                      <img src="../assets/medilinkPC/plus.png" alt="" />
                      <span class="txt_">{{
                        $t("InsuranceInfo[3]") || "添加连带被保险人保险卡"
                      }}</span>
                    </div>
                    <a-button
                      type="primary"
                      size="small"
                      @click="goWelfare(item)"
                      >{{ $t("InsuranceInfo[4]") || "保险福利" }}</a-button
                    >
                  </div>
                </div>
                <div class="con_">
                  <span class="mr_"
                    ><span>{{ $t("InsuranceInfo[2]") || "主被保险人" }}：</span
                    ><span>{{ item.empName }}</span></span
                  >
                  <span class="mr_"
                    ><span>{{ $t("InsuranceInfo[5]") || "保险卡号" }}：</span
                    ><span>{{ item.cardNo }}</span></span
                  >
                  <span class="mr_"
                    ><span>{{ $t("InsuranceInfo[6]") || "投保人" }}：</span
                    ><span>{{ item.corpCode }}</span></span
                  >
                  <span class="mr_"
                    ><span>{{ $t("InsuranceInfo[7]") || "保险产品" }}：</span
                    ><span>{{ item.description }}</span></span
                  >
                  <span class="mr_" style="width:60%"
                    ><span>{{ $t("InsuranceInfo[8]") || "保障有效期" }}：</span
                    ><span
                      >{{ item.startDate }} - {{ item.endDate }}</span
                    ></span
                  >
                </div>
              </div>
              <div class="main_info_" v-if="item.depenList.length > 0">
                <div v-for="(item2, index2) in item.depenList" :key="index2">
                  <div class="top">
                    <span class="left_">{{
                      $t("InsuranceInfo[9]") || "连带保险人"
                    }}</span>
                    <div class="right_">
                      <a-button
                        type="primary"
                        size="small"
                        @click="goWelfare(item2, item, '1')"
                        >{{ $t("InsuranceInfo[4]") || "保险福利" }}</a-button
                      >
                    </div>
                  </div>
                  <div class="con_">
                    <span class="mr_"
                      ><span
                        >{{ $t("InsuranceInfo[9]") || "连带保险人" }}：</span
                      ><span>{{ item2.empName }}</span></span
                    >
                    <span class="mr_"
                      ><span>{{ $t("InsuranceInfo[5]") || "保险卡号" }}：</span
                      ><span>{{ item2.cardNo }}</span></span
                    >
                    <span class="mr_"
                      ><span>{{ $t("InsuranceInfo[6]") || "投保人" }}：</span
                      ><span>{{ item2.corpCode }}</span></span
                    >
                    <span class="mr_"
                      ><span>{{ $t("InsuranceInfo[7]") || "保险产品" }}：</span
                      ><span>{{ item2.description }}</span></span
                    >
                    <span class="mr_" style="width:60%"
                      ><span
                        >{{ $t("InsuranceInfo[8]") || "保障有效期" }}：</span
                      ><span
                        >{{ item2.startDate }} - {{ item2.endDate }}</span
                      ></span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="nodata" v-else>
            <img src="../assets/medilinkPC/nodata.jpg" alt="" />
          </div>
        </a-tab-pane>
        <a-tab-pane
          key="2"
          :tab="$t('InsuranceInfo[10]') || '历史保单'"
          force-render
        >
          <div class="box_" v-if="hisPolicyList.length > 0">
            <div
              v-for="(item, index) in hisPolicyList"
              :key="index"
              style="margin-bottom: 20px;"
            >
              <p class="tit_">
                {{ $t("InsuranceInfo[1]") || "保单号" }}：{{ item.policyNo }}
              </p>
              <div class="main_info_" v-if="item.show != '1'">
                <div class="top">
                  <span class="left_">{{
                    $t("InsuranceInfo[2]") || "主被保险人"
                  }}</span>
                  <div class="right_">
                    <div class="add" @click="addCard">
                      <img src="../assets/medilinkPC/plus.png" alt="" />
                      <span class="txt_">{{
                        $t("InsuranceInfo[3]") || "添加连带被保险人保险卡"
                      }}</span>
                    </div>
                    <a-button
                      type="primary"
                      size="small"
                      @click="goWelfare(item)"
                      >{{ $t("InsuranceInfo[4]") || "保险福利" }}</a-button
                    >
                    <!-- <router-link :to="{name : 'Benefits',query: {
                        memberNo: memberNo,
                        policyNo: item.policyNo,
                        startDate: item.startDate,
                        endDate: item.endDate,
                        empPlanId: item.empPlanId,
                        prodName: item.description
                      }}"><a-button type="primary" size="small">保险福利</a-button></router-link> -->
                  </div>
                </div>
                <div class="con_">
                  <span class="mr_"
                    ><span>{{ $t("InsuranceInfo[2]") || "主被保险人" }}：</span
                    ><span>{{ item.empName }}</span></span
                  >
                  <span class="mr_"
                    ><span>{{ $t("InsuranceInfo[5]") || "保险卡号" }}：</span
                    ><span>{{ item.cardNo }}</span></span
                  >
                  <span class="mr_"
                    ><span>{{ $t("InsuranceInfo[6]") || "投保人" }}：</span
                    ><span>{{ item.corpCode }}</span></span
                  >
                  <span class="mr_"
                    ><span>{{ $t("InsuranceInfo[7]") || "保险产品" }}：</span
                    ><span>{{ item.description }}</span></span
                  >
                  <span class="mr_" style="width:60%"
                    ><span>{{ $t("InsuranceInfo[8]") || "保障有效期" }}：</span
                    ><span
                      >{{ item.startDate }} - {{ item.endDate }}</span
                    ></span
                  >
                </div>
              </div>
              <div class="main_info_" v-if="item.depenList.length > 0">
                <div v-for="(item2, index2) in item.depenList" :key="index2">
                  <div class="top">
                    <span class="left_">{{
                      $t("InsuranceInfo[9]") || "连带保险人"
                    }}</span>
                    <div class="right_">
                      <a-button
                        type="primary"
                        size="small"
                        @click="goWelfare(item2, item, '1')"
                        >{{ $t("InsuranceInfo[4]") || "保险福利" }}</a-button
                      >
                    </div>
                  </div>
                  <div class="con_">
                    <span class="mr_"
                      ><span
                        >{{ $t("InsuranceInfo[9]") || "连带保险人" }}：</span
                      ><span>{{ item2.empName }}</span></span
                    >
                    <span class="mr_"
                      ><span>{{ $t("InsuranceInfo[5]") || "保险卡号" }}：</span
                      ><span>{{ item2.cardNo }}</span></span
                    >
                    <span class="mr_"
                      ><span>{{ $t("InsuranceInfo[6]") || "投保人" }}：</span
                      ><span>{{ item2.corpCode }}</span></span
                    >
                    <span class="mr_"
                      ><span>{{ $t("InsuranceInfo[7]") || "保险产品" }}：</span
                      ><span>{{ item2.description }}</span></span
                    >
                    <span class="mr_" style="width:60%"
                      ><span
                        >{{ $t("InsuranceInfo[8]") || "保障有效期" }}：</span
                      ><span
                        >{{ item2.startDate }} - {{ item2.endDate }}</span
                      ></span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="nodata" v-else>
            <img src="../assets/medilinkPC/nodata.jpg" alt="" />
          </div>
        </a-tab-pane>
        <a-input
          slot="tabBarExtraContent"
          :placeholder="$t('InsuranceInfo[11]') || '请输入保单/保险卡号'"
          v-model="cardNo"
          @input="changeInput"
          style="top:10px;"
        >
          <!-- <a-icon slot="prefix" type="search"></a-icon> -->
          <img slot="prefix" src="../assets/medilinkPC/search.png" alt="" />
        </a-input>
      </a-tabs>
    </div>
    <a-modal
      v-model="addVisible"
      :footer="null"
      width="450px"
      style="height: 290px;"
      class="model_b"
    >
      <div class="btn_box">
        <div style="font-weight: 600;font-size: 16px;">
          {{ $t("InsuranceInfo[3]") || "添加连带被保险人保险卡" }}
        </div>
        <a-input
          class="card_ card_input"
          v-model="form.cardNo"
          style="width: 405px;;margin-top: 20px;margin-bottom: 10px;"
          :placeholder="$t('InsuranceInfo[12]') || '请输入8000开头的保险卡号'"
          size="large"
        >
          <img
            slot="prefix"
            src="../assets/medilinkPC/cardno.svg"
            alt=""
            style="margin-right:5px;"
          />
          <!-- <a-icon slot="prefix" type="search"></a-icon> -->
        </a-input>
        <a-input
          v-model="form.password"
          class="card_ card_input"
          style="width: 405px;margin-bottom: 20px;"
          :placeholder="
            $t('InsuranceInfo[13]') ||
              '请输入密码（初始密码为证件的后六位字符）'
          "
          size="large"
        >
          <img
            slot="prefix"
            src="../assets/medilinkPC/pwd.svg"
            alt=""
            style="margin-right:5px;"
          />
        </a-input>
        <a-row
          type="flex"
          justify="space-between"
          style="width:100%;display:flex;justify-content:space-between;"
        >
          <a-button
            type="primary"
            size="small"
            style="width: 180px;height:40px;"
            @click="bindCardInfo"
            >{{ $t("InsuranceInfo[14]") || "保存" }}</a-button
          >
          <a-button
            size="small"
            style="width:180px;height:40px;"
            @click="cancel"
            >{{ $t("InsuranceInfo[15]") || "取消" }}</a-button
          >
        </a-row>
      </div>
    </a-modal>
  </div>
</template>

<style lang="scss" scoped>
.btn_box {
  .ant-btn-primary {
    background-color: #2c5acc;
    border-color: #2c5acc;
  }
}
.page_ {
  // height: 98%;
  background-color: #fff;
  width: 100%;
  padding: 0 27px;
  border-radius: 10px;
  min-height: 84vh;

  .tit_ {
    font-weight: 500;
    // border-left: 3px #2C5ACC solid;
    padding-left: 10px;
    position: relative;
    font-weight: bold;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0;
      left: 0;
      width: 3px;
      height: 14px;
      background-color: #2c5acc;
    }
  }
  .main_info_ {
    width: 100%;
    border-radius: 10px;
    margin-bottom: 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    .top {
      border: 1px solid #eee;
      border-bottom: 0;
      // border-radius: 10px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      width: 100%;
      height: 46px;
      background-color: #fafafa;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      .left_ {
        font-weight: bold;
      }
      .right_ {
        display: flex;
        align-items: center;
        .add {
          display: flex;
          align-items: center;
          img {
            width: 10px;
            height: 10px;
            padding-bottom: 1px;
          }
          .txt_ {
            cursor: pointer;
            color: #2c5acc;
            margin: 0 20px 0 10px;
          }
        }
      }
    }
    .con_ {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      color: #394155;
      width: 100%;
      // height: 42px;
      line-height: 42px;
      padding: 15px 20px 5px;
      border: 1px #eee solid;
      border-top: none;
      &:last-child {
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
      }
      .mr_ {
        font-size: 14px;
        margin-right: 60px;
        width: 32%;
        margin-right: 2%;
        display: flex;
        margin-bottom: 10px;
        span:nth-child(1) {
          white-space: nowrap;
        }
        span {
          line-height: 20px;
        }
        &:nth-child(3n + 3) {
          margin-right: 0;
        }
      }
    }
  }
}
.page_ .ant-modal-content {
  height: 290px;
}
.nodata img {
  width: 81px;
  height: 91px;
  position: relative;
  display: block;
  margin: 100px auto 0;
}
</style>

<script>
import api from "@/utils/api";
const columns = [
  {
    title: "Name",
    dataIndex: "name"
  },
  {
    title: "Age",
    dataIndex: "age"
  },
  {
    title: "Address",
    dataIndex: "address"
  }
];
export default {
  data() {
    return {
      addVisible: false,
      cardNo: "",
      memberNo: "",
      effectivePolicyList: [],
      hisPolicyList: [],
      form: {
        cardNo: "",
        password: "",
        memberNo: ""
      },
      userInfo: {}
    };
  },
  mounted() {
    this.memberNo = localStorage.getItem("memberNo");
    this.form.memberNo = localStorage.getItem("memberNo");
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.queryEffectivePolicy();
    this.queryHisPolicy();
  },
  methods: {
    changeInput() {
      // 有效保单
      this.queryEffectivePolicy();
      // 历史保单
      this.queryHisPolicy();
    },
    cancel() {
      this.addVisible = false;
    },
    bindCardInfo() {
      if (this.form.password && this.form.cardNo) {
        api
          .bindCardInfo(this.form)
          .then(res => res.data)
          .then(data => {
            this.$message.success(data.msg);
            this.addVisible = false;
          });
      } else {
        if (this.$i18n.locale == "zh-cn") {
          this.$message.error("保险卡号或密码不能为空");
        } else {
          this.$message.error(
            "The insurance card or the password can't be null!"
          );
        }
      }
    },
    queryEffectivePolicy() {
      api
        .queryEffectivePolicy({ cardNo: this.cardNo })
        .then(res => res.data)
        .then(data => {
          this.effectivePolicyList = data.data;
        });
    },
    queryHisPolicy() {
      api
        .queryHisPolicy({ cardNo: this.cardNo })
        .then(res => res.data)
        .then(data => {
          this.hisPolicyList = data.data;
        });
    },
    addCard() {
      this.addVisible = true;
    },
    goWelfare(item, itemmain, type) {
      localStorage.setItem("corpCode", item.corpCode);
      localStorage.setItem("welfareParams", JSON.stringify(item));
      if (type) {
        this.$router.push({
          name: "Benefits",
          query: {
            description: itemmain.description,
            payorName: itemmain.payorName
          }
        });
      } else {
        this.$router.push({
          name: "Benefits"
        });
      }
    }
  }
};
</script>
